import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const NumberInputValue = ({ rule, onValueChange }) => (
  <Input
    type='number'
    value={rule.numberValue}
    onChange={(e, data) => onValueChange(rule.instanceId, data.value)}
    input={{ 'data-testid': `number-input-${rule.id}` }}
  />
);

NumberInputValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default NumberInputValue;
